import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { isDemoModeEnabled } from '../demo/demoRuntime';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

const demoMode = isDemoModeEnabled();
const app = demoMode ? null : initializeApp(firebaseConfig);
export const auth = demoMode ? null : getAuth(app);
export const db = demoMode ? null : getFirestore(app);
export const storage = demoMode ? null : getStorage(app);

export default app;
